import React, { useEffect, useState } from "react";
import axios from "axios";
import Table from 'react-bootstrap/Table';
import RemoveOrderModal from "./modals/RemoveOrderModal";
import { Baseurl } from "../constants/env";
const Ordersdet = ({
  id,
  index,
  date,
  name,
  adress,
  mobile,
  totalprice,
  removechange
}) => {
  const [data, setData] = useState([]);
  const [length, setLength] = useState([]);

  useEffect(() => {
    productdata();
  }, []);

  async function productdata() {
    await axios(`${Baseurl}/orderedproductdetails/${id}`, {
      withCredentials: true,
    })
      .then((resp) => {
        setData(resp.data.data);
        setLength(resp.data.data.length);
      })
      .catch((e) => {
        console.log(e.message);
      });
  }



  return (

    
    <div className="bg-info" style={{marginTop:'150px'}}>

  <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="mb-3">
         <small style={{fontWeight:'100'}}>Order No</small><span style={{fontSize:'40px'}}> {index}</span> 
          <small style={{fontWeight:'100',marginLeft:'150px'}}>Total Items</small><span style={{fontSize:'40px'}}> {length}</span> 

        </div>
        </div>
       </div>

       <Table striped bordered hover>
        <thead className="text-center">
          <tr>
            <th>Orderd Date</th>
            <th>Customer Name</th>
            <th>Customer Adress</th>
            <th>Mobile No</th>
            <th>Product Name</th>
            <th>Product Price</th>
           
          </tr>
        </thead>
        <tbody className="text-center">

        {data?.products?.map((item, index) => {
            return (
              <tr key={index + 3}>
             
              <td>{ date }</td>
            <td>{name}</td>
            <td>{adress}</td>
            <td>{mobile}</td>
             
                <td>
                  
                  {item.name}
                </td>
                <td>
                
                 $ {item.ourprice}
                </td>
              </tr>
            );
          })} 
        
         
        </tbody>
       
      
     </Table>

     
      <div className="row">
        <div className="col-md-6 mb-5 ">
          <div>
          <small style={{fontWeight:'100'}}>Total Price </small><span style={{fontSize:'40px'}}>$.{totalprice}</span> 
          </div>
        </div>
        <div className="col-md-6 mb-5">
          <div className="mt-3 ">
         <RemoveOrderModal  id={id} removechange={removechange} /> 

          </div>
        </div>
        <hr></hr>
      </div>
    

    </div>
       
    </div>

   
  );
};

export default Ordersdet;
